import React, { memo } from 'react';
import { FadeIn } from './ui/FadeIn';
export function OpeningHook() {
  return <section className="bg-cream py-24 px-4 relative" data-id="element-164">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-px bg-copper" data-id="element-165" />

      <div className="max-w-3xl mx-auto text-center" data-id="element-166">
        <FadeIn data-id="element-167">
          <p className="text-2xl md:text-3xl font-heading text-navy leading-relaxed mb-8" data-id="element-168">
            You didn't ask for those keys.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-169">
          <p className="text-lg md:text-xl text-text-dark/80 font-body leading-loose mb-8" data-id="element-170">
            You didn't ask for the piles of legal paperwork, the aggressive
            calls from the bank, or the property taxes that don't care that
            you're still grieving.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-171">
          <p className="text-lg md:text-xl text-text-dark/80 font-body leading-loose" data-id="element-172">
            For most, inheriting a home feels like a windfall. For you—standing
            in a living room full of someone else's memories while a mortgage
            you didn't sign for ticks toward foreclosure—
            <span className="font-semibold text-navy" data-id="element-173">
              it feels like a trap.
            </span>
          </p>
        </FadeIn>
      </div>
    </section>;
}